var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"CLOSE"),React.createElement("g",{"id":"CLOSE","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("polyline",{"id":"Path-Copy","stroke":"#E85633","strokeWidth":"2","points":"21.0173217 5 13.0104011 13.1160463 5 5.06039791","key":0}),React.createElement("polyline",{"id":"Path-Copy-2","stroke":"#E85633","strokeWidth":"2","transform":"translate(12.008661, 16.058023) rotate(180.000000) translate(-12.008661, -16.058023) ","points":"20.0173217 12 12.0104011 20.1160463 4 12.0603979","key":1})])]);
}

Close.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Close;

Close.default = Close;
